module.exports = __webpack_public_path__ + "static/media/image.231c2e13.svg";